import React from 'react'
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { STRINGS } from '@/app/constants/componentStrings';
import { Button } from 'primereact/button';
import { templates } from '../common/componentDefaultTemplates';
import DocumentImageService from '@/app/api/service/DocumentImageService';

function Laudos( {laudos} ){

    const visualizarDocLaudoTemplate = (rowData) => (
        <Button type="button" onClick={ e => { e.preventDefault(); DocumentImageService.visualizarDocumento('laudo', rowData.id)} }
                icon="pi pi-download" 
                className="p-button-primary"
                style={{marginRight: '.5em'}}>
        </Button>
    )

    return(
        <DataTable value={laudos} emptyMessage={STRINGS.emptyMessage}>
            <Column field="numero" header="Número" />
            <Column body={templates.VALOR_TEMPLATE} header="Valor" className="t-right" />
            <Column header="Data" body={templates.DATA_LOCALDATE_TEMPLATE} />
            <Column  body={visualizarDocLaudoTemplate} className="coluna-acao" />
        </DataTable>
    )
}

export default Laudos